import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { Box } from '@chakra-ui/react';
import { NextSeo } from 'next-seo';
import { Navbar } from '@/components/chakraUIPro/Navbar';
import { Footer } from '@/components/chakraUIPro/Footer';
import Loading from '@/components/Loading';
import { HeroMain } from '@/components/LandingPage/HeroMain';
import { HomepageSections } from '@/components/LandingPage/Sections';
import styles from '@/components/LandingPage/HomepageSections.module.scss';
import { AppRouteLoadingShell } from '@/components/Routing/AppRouteLoadingShell';
import { useStaticExportRedirect } from '@/hooks/useStaticExportRedirect';

const openGraphLocales: Record<string, string> = {
  en: 'en_GB',
  fr: 'fr_FR',
  de: 'de_DE',
  es: 'es_ES'
};

const Index = () => {
  const router = useRouter();
  const { t, i18n } = useTranslation('landing');
  const [mounted, setMounted] = useState(false);
  const { isAppRedirect, isRedirecting } = useStaticExportRedirect(mounted);
  const authCallbackPath = router.query.code ? `/auth/callback${router.asPath.slice(1)}` : null;
  const currentLanguage = i18n.resolvedLanguage?.substring(0, 2) || 'en';

  useEffect(() => setMounted(true), []);

  useEffect(() => {
    if (router.isReady && authCallbackPath) {
      router.replace(authCallbackPath).catch((err) => {
        console.error('SSO callback redirect error', { err });
      });
    }
  }, [authCallbackPath, router.isReady, router.replace]);

  if (isRedirecting) {
    return isAppRedirect ? <AppRouteLoadingShell /> : <Loading />;
  }

  return (
    <>
      <div data-static-app-route-shell=''>
        <AppRouteLoadingShell />
      </div>
      <NextSeo
        title={t('homepage.seo.title')}
        description={t('homepage.seo.description')}
        canonical='https://eezi.io/'
        openGraph={{
          url: 'https://eezi.io/',
          title: t('homepage.seo.title'),
          description: t('homepage.seo.openGraphDescription'),
          locale: openGraphLocales[currentLanguage] || openGraphLocales.en
        }}
      />
      <Box className={styles.homepagePage} data-static-marketing-route='' bg='bg-default' position='relative'>
        <Navbar py={4} homepageGutter />
        <HeroMain />
        <HomepageSections />
      </Box>
      <Box className={styles.homepagePage} data-static-marketing-route='' bg='bg-default'>
        <Box maxW='1384px' mx='auto' px='var(--homepage-gutter)' py={8} textAlign='left'>
          <Footer />
        </Box>
      </Box>
    </>
  );
};

export default Index;
